module.exports = __webpack_public_path__ + "img/08.ee35c0dc.jpg";